<mat-form-field class="w-100">
	<input matInput placeholder="Billing Address" [formControl]="searchControl"
		[matAutocomplete]="billingAddressAuto" />
	<mat-autocomplete #billingAddressAuto="matAutocomplete" [displayWith]="displayAddress"
		(optionSelected)="addressSelected.emit($event.option.value)">
		<mat-option *ngFor="let ca of filteredAddresses$ | async" [value]="ca">
			{{ formatAddress(ca.address) }}
			<span *ngIf="ca.isDefault"> (Default)</span>
		</mat-option>
	</mat-autocomplete>
</mat-form-field>